module.exports = __webpack_public_path__ + "static/img/background-1.c892ef5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-1.jpg
// module id = jObJ
// module chunks = 0